import React, { useState } from "react";
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import { Link } from "polyrouter";
import { useTranslation } from "utilities/i18n";
import { PolyIcon } from "elements";

export const SizeAlert: React.FC = () => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  const dismissSizeAlert = () => {
    setDismissed(true);
  };

  if (dismissed) {
    return <></>;
  }

  return (
    <div
      aria-hidden="true"
      className={isMobile ? "mobile-alert" : "min-size-alert"}
      data-testid="size-alert-testid"
    >
      <DismissControl dismissFcn={dismissSizeAlert} />
      <div className="info">
        <MobileView>
          <p>{t("MOBILE_DIRECTIONS")}</p>
          <Link to="/about">{t("ABOUT_LENS")}</Link>
        </MobileView>
        <BrowserView>
          <p data-testid="resolution-info">{t("DESKTOP_SIZE_ALERT")}</p>
        </BrowserView>
      </div>
      <MobileView>
        <Link data-testid="register" to="/go" className="register">
          {t("REGISTER_DEVICE")}
        </Link>
      </MobileView>
    </div>
  );
};

const DismissControl: React.FC<{
  dismissFcn?: () => void;
}> = ({ dismissFcn }) => {
  if (isMobile) {
    return <></>;
  }

  const invokeDismissFcn = () => {
    dismissFcn && dismissFcn();
  };

  return (
    <span
      className="clear-icon"
      data-testid="close-min-size-alert"
      onClick={invokeDismissFcn}
    >
      <PolyIcon className="clear-icon" title="close" icon="clear_x" />
    </span>
  );
};

export default SizeAlert;
